export default "__VITE_ASSET__D8ueqXo9__"